import {
  addFilter,
  addPagination
} from 'portaltransparencia-common/libs/AddFilter';
import StorageService from 'portaltransparencia-common/libs/StorageService';

const EMENDA_FILTERS = [
  'numero',
  'planoAcao',
  'numeroLeiAto',
  'nomeAutor',
  'objetivoFinalidade',
  'tipoTransferencia',
  'origemEmenda',
  'valorPrevisto',
  'valorRepassado',
  'localidadeBeneficiada',
  'partido'
];

const PROGRAMATICA_FILTERS = [
  'orgao',
  'unidade',
  'funcao',
  'subFuncao',
  'programa',
  'projeto',
  'elemento',
  'desdobramento',
  'subDesdobramento',
  'fonteRecurso'
];

const PROGRAMATICA_PREFIX = 'programatica.';

export function buildParamsQuery(filters) {
  const urlFilter = [];

  EMENDA_FILTERS.forEach(filterName => {
    addFilter(urlFilter, filterName, filters.get(filterName));
  });

  PROGRAMATICA_FILTERS.forEach(filterName => {
    const item = filters.get(filterName);
    if (item) {
      addFilter(
        urlFilter,
        PROGRAMATICA_PREFIX + filterName,
        item.get('codigo')
      );
    }
  });

  return urlFilter.join('&');
}

export function buildUrl(url, filters, page) {
  const userInfo = StorageService.getItem('userInfo');
  const { entidade, exercicio } = userInfo;
  const base = `${url}?entidade=${entidade.id}&exercicio=${exercicio.id}`;
  const paramsQuery = filters ? buildParamsQuery(filters) : '';
  const pageQuery = page ? addPagination(page) : '';

  return [base, paramsQuery, pageQuery].filter(Boolean).join('&');
}
